module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEnvironmentPc()) ? _c('div', {
    class: [_vm.layoutObj.containerClass, _vm.activeType, 'cards-container']
  }, [_vm._l((_vm.layoutObj.actNums.length), function(rowIndex) {
    return [_c('div', {
      key: rowIndex,
      staticClass: "group-column",
      attrs: {
        "id": 'group' + rowIndex
      }
    }, [_vm._l((_vm.layoutObj.actNums[rowIndex - 1].length), function(classIndex) {
      return [(!_vm.horizontalRow) ? [_c('div', {
        key: classIndex,
        staticClass: "card-inner card-voice",
        class: _vm.layoutObj.innerClasses[rowIndex - 1][classIndex - 1]
      }, [_vm._l((_vm.layoutObj.actNums[rowIndex - 1][classIndex - 1]), function(actIndex) {
        return [_c('div', {
          key: actIndex,
          staticClass: "item",
          class: {
            challenge: !_vm.isAnswers[_vm.getTargetAct(rowIndex, classIndex, actIndex)] & _vm.actChoice & _vm.isChallenge(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            type1: !_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] & !_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            active: _vm.isActivesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            disabled: !_vm.actChoice & _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].inDisabled,
            context: _vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          },
          style: ({
            cursor: _vm.cursorTypes[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }),
          attrs: {
            "id": 'Item' + _vm.getTargetAct(rowIndex, classIndex, actIndex)
          },
          on: {
            "click": function($event) {
              _vm.clickItem(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }, [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && _vm.showPinchInBtn),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] && showPinchInBtn"
          }],
          staticClass: "icon-pinch-in",
          on: {
            "click": function($event) {
              _vm.clickPinchIn(
                _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }), _vm._v(" "), (_vm.actTextListChild.length != 0) ? [(_vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)]) ? _c('div', [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('div', {
          staticClass: "select",
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].answerText))
          }
        })]) : _c('div', {
          staticClass: "select",
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].answerText))
          }
        })])]) : _c('div', [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('div', {
          staticClass: "select",
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].questionText))
          }
        })]) : _c('div', {
          staticClass: "select",
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].questionText))
          }
        })])])] : [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('p', {
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)]))
          }
        })]) : _c('p', {
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage),
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)]))
          }
        })])], _vm._v(" "), _c('div', {
          staticClass: "card"
        }, [_c('div', {
          class: {
            correct: _vm.isCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            incorrect: _vm.isInCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "image"
        }, [_c('img', {
          attrs: {
            "src": _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].image
          }
        }), _vm._v(" "), (_vm.hasImageText(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('p', {
          class: _vm.getImageTextFontClass(_vm.$parent.productLanguage, _vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType))
        }, [_vm._v("\n                      " + _vm._s(_vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && !_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)] && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])"
          }],
          staticClass: "icon-voice",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        })])], 2)]
      })], 2)] : [_c('div', {
        key: classIndex,
        staticClass: "card-inner",
        class: _vm.layoutObj.innerClasses[rowIndex - 1][classIndex - 1]
      }, [_vm._l((_vm.layoutObj.actNums[rowIndex - 1][classIndex - 1]), function(actIndex) {
        return [_c('div', {
          key: actIndex,
          staticClass: "item",
          class: {
            complete: _vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            active: _vm.isActivesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          },
          style: ({
            cursor: _vm.cursorTypes[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }),
          attrs: {
            "id": 'Item' + _vm.getTargetAct(rowIndex, classIndex, actIndex)
          }
        }, [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          staticClass: "icon-voice",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "item-inner",
          class: {
            challenge: _vm.actChoice && !_vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && _vm.isChallenge(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          },
          style: ({
            cursor: _vm.cursorTypes[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }),
          on: {
            "click": function($event) {
              _vm.clickItem(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }, [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && _vm.showPinchInBtn),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] && showPinchInBtn"
          }],
          staticClass: "icon-pinch-in",
          on: {
            "click": function($event) {
              _vm.clickPinchIn(
                _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "word",
          class: _vm.getTextFontClassAct(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.$parent.productLanguage)
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)]))
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "card"
        }, [_c('div', {
          class: {
            correct: _vm.isCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            incorrect: _vm.isInCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }
        }), _vm._v(" "), (_vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)]) ? _c('div', {
          staticClass: "aimage"
        }, [_c('img', {
          attrs: {
            "src": _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].image
          }
        })]) : _c('div', {
          staticClass: "aimage"
        }, [_c('img', {
          attrs: {
            "src": "/static/images/blank.jpg"
          }
        })])])])])]
      })], 2)]]
    })], 2)]
  })], 2) : _c('div', {
    staticClass: "cards-container",
    class: [_vm.layoutObj.containerClass, _vm.activeType, _vm.swiperContainer1ClassName]
  }, [_c('div', {
    class: _vm.swiperWrapperClassName
  }, [_vm._l((_vm.layoutObj.actNums.length), function(rowIndex) {
    return [_vm._l((_vm.layoutObj.actNums[rowIndex - 1].length), function(classIndex) {
      return [(!_vm.horizontalRow) ? [_c('div', {
        key: 'row' + rowIndex + 'class' + classIndex,
        staticClass: "card-inner card-voice",
        class: [_vm.layoutObj.innerClasses[rowIndex - 1][classIndex - 1], _vm.swiperSlideClassName]
      }, [_c('div', {
        class: _vm.swiperContainer2ClassName
      }, [_c('div', {
        class: _vm.swiperWrapperClassName
      }, [_vm._l((_vm.layoutObj.actNums[rowIndex - 1][classIndex - 1]), function(actIndex) {
        return [_c('div', {
          key: actIndex,
          staticClass: "item",
          class: [{
            challenge: !_vm.isAnswers[_vm.getTargetAct(rowIndex, classIndex, actIndex)] & _vm.actChoice & _vm.isChallenge(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            type1: !_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] & !_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            active: _vm.isActivesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            disabled: !_vm.actChoice & _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].inDisabled,
            context: _vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          }, _vm.swiperSlideClassName],
          attrs: {
            "id": 'Item' + _vm.getTargetAct(rowIndex, classIndex, actIndex)
          },
          on: {
            "click": function($event) {
              _vm.clickItem(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.getTargetAct(rowIndex, classIndex, actIndex))
            },
            "touchstart": function($event) {
              _vm.onTouchStart(
                _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.getTargetAct(rowIndex, classIndex, actIndex))
            },
            "touchend": function($event) {
              return _vm.onTouchEnd()
            },
            "touchmove": function($event) {
              return _vm.onTouchEnd()
            }
          }
        }, [(_vm.actTextListChild.length != 0) ? [(_vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)]) ? _c('div', [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('div', {
          staticClass: "select",
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].answerText)
          }
        })]) : _c('div', {
          staticClass: "select",
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].answerText)
          }
        })])]) : _c('div', [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('div', {
          staticClass: "select",
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].questionText)
          }
        })]) : _c('div', {
          staticClass: "select",
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)].questionText)
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "card"
        }, [_c('div', {
          class: {
            correct: _vm.isCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            incorrect: _vm.isInCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "image"
        }, [_c('img', {
          attrs: {
            "src": _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].image
          }
        }), _vm._v(" "), (_vm.hasImageText(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('p', {
          directives: [{
            name: "auto-adjust",
            rawName: "v-auto-adjust"
          }],
          class: _vm.isImageTextAutoAdjust ? '' : _vm.getImageTextFontClass(_vm.$parent.productLanguage, _vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType))
        }, [_vm._v("\n                            " + _vm._s(_vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType)) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && !_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]  && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])"
          }],
          staticClass: "icon-voice",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        })])] : [_c('div', [(!_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('p', {
          staticStyle: {
            "visibility": "visible"
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          }
        })]) : _c('p', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "card"
        }, [_c('div', {
          class: {
            correct: _vm.isCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            incorrect: _vm.isInCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "image"
        }, [_c('img', {
          attrs: {
            "src": _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].image
          }
        }), _vm._v(" "), (_vm.hasImageText(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])) ? _c('p', {
          directives: [{
            name: "auto-adjust",
            rawName: "v-auto-adjust"
          }],
          class: _vm.isImageTextAutoAdjust ? '' : _vm.getImageTextFontClass(_vm.$parent.productLanguage, _vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType))
        }, [_c('span', [_vm._v(_vm._s(_vm.getImageText(_vm.$parent.productLanguage, _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.scriptType)))])]) : _vm._e()]), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && !_vm.isContext(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]  && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])"
          }],
          staticClass: "icon-voice",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        })])])]], 2)]
      })], 2)])])] : [_c('div', {
        key: 'row' + rowIndex + 'class' + classIndex,
        staticClass: "card-inner card-voice",
        class: [_vm.layoutObj.innerClasses[rowIndex - 1][classIndex - 1], _vm.swiperSlideClassName]
      }, [_c('div', {
        class: _vm.swiperContainer2ClassName
      }, [_c('div', {
        class: _vm.swiperWrapperClassName
      }, [_vm._l((_vm.layoutObj.actNums[rowIndex - 1][classIndex - 1]), function(actIndex) {
        return [_c('div', {
          key: actIndex,
          staticClass: "item",
          class: [{
            complete: _vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            active: _vm.isActivesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }, _vm.swiperSlideClassName],
          attrs: {
            "id": 'Item' + _vm.getTargetAct(rowIndex, classIndex, actIndex)
          },
          on: {
            "touchstart": function($event) {
              _vm.onTouchStart(
                _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.actTextListChild[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.showAnswerText[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
                _vm.getTargetAct(rowIndex, classIndex, actIndex))
            },
            "touchend": function($event) {
              return _vm.onTouchEnd()
            },
            "touchmove": function($event) {
              return _vm.onTouchEnd()
            }
          }
        }, [_c('div', [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          staticClass: "icon-voice",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "item-inner",
          class: {
            challenge: _vm.actChoice && !_vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)] && _vm.isChallenge(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          },
          on: {
            "click": function($event) {
              _vm.clickItem(_vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)], _vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        }, [_c('p', {
          staticClass: "word"
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowTextsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          domProps: {
            "innerHTML": _vm._s(_vm.basicTextList[_vm.getTargetAct(rowIndex, classIndex, actIndex)])
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "card"
        }, [_c('div', {
          class: {
            correct: _vm.isCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)],
            incorrect: _vm.isInCorrectsAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]
          }
        }), _vm._v(" "), (_vm.isCompletes[_vm.getTargetAct(rowIndex, classIndex, actIndex)]) ? _c('div', {
          staticClass: "aimage"
        }, [_c('img', {
          attrs: {
            "src": _vm.pathstep.acts[_vm.getTargetAct(rowIndex, classIndex, actIndex)].image
          }
        })]) : _c('div', {
          staticClass: "aimage"
        }, [_c('img', {
          attrs: {
            "src": "/static/images/blank.jpg"
          }
        })]), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowVoicesAct[_vm.getTargetAct(rowIndex, classIndex, actIndex)]),
            expression: "isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]"
          }],
          staticClass: "icon-voice icon-voice02",
          on: {
            "click": function($event) {
              _vm.actAudioPlay(_vm.getTargetAct(rowIndex, classIndex, actIndex))
            }
          }
        })])])])])]
      })], 2)])])]]
    })]
  })], 2), _vm._v(" "), (_vm.needsSwiper) ? _c('div', {
    class: {
      'swiper-pagination': _vm.actChoice
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-69775cbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-69775cbf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/CommonAct.vue
// module id = 872
// module chunks = 1